import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'components/ui/index';
import Label from 'components/ui/form/label';
import Popover from 'components/ui/popover';
import { useI18n } from 'hooks/use_i18n';

import 'components/ui/file.scss';
import ConfirmButton from 'components/ui/confirm_button';

const iconContentType = {
  'application/zip': 'zip-file',
  'application/pdf': 'pdf-file',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx-file',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'office-file-xls-1',
};

const File = ({ blob, removeFile, className, deletable }) => {
  const isImage = blob.image;
  const { t } = useI18n();
  return (
    <div className={`d-inline-flex align-center border p-1 rounded-soft bg-white my-1 fs--1 file-block ${className}`}>
      <a href={blob.file_url} target="_blank" className="text-decoration-none">
        <Label id={`preview_${blob.id}`} className="mb-0 cursor-pointer d-flex">
          <Icon name={isImage ? 'image-file' : iconContentType[blob.content_type] || 'common-file'} />
          <span className="mx-2">{blob.filename}</span>
        </Label>
      </a>
      {isImage && (
        <Popover placement="top-start" trigger="hover" target={`preview_${blob.id}`}>
          <img width="100%" src={blob.thumb_url} alt={blob.filename} />
        </Popover>
      )}
      {deletable && (
        <>
          <ConfirmButton as="text" className="mb-0 cursor-pointer d-flex delete-file-btn" onClick={() => removeFile && removeFile(blob)}>
            <Icon name="close" className="remove-icon" id={`delete_${blob.id}`} />
          </ConfirmButton>
        </>
      )}
    </div>
  );
};
File.propTypes = {
  blob: PropTypes.object.isRequired,
  onRemoveUpload: PropTypes.func,
  deletable: PropTypes.bool,
};

export default File;
